import infinity from '../elements/infinity.js';
infinity.register();
